class MinicartItem extends HTMLElement {
  enableDynamicFlexContent = false;
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }

  init() {
    this.handleProductNameUpdate();
    this.setFlexContent();
    this.setupListeners();
  }

  checkTitleIsClamp(element) {
    if (!element) return false;

    // Get computed styles
    const styles = window.getComputedStyle(element);
    const lineHeight = parseFloat(styles.lineHeight);
    const clampValue = parseFloat(styles.webkitLineClamp);

    // If no clamp is set, return false
    if (isNaN(clampValue)) return false;

    // Compare scrollHeight with visible height
    // scrollHeight > clientHeight means content is overflowing the clamp
    return element.scrollHeight > element.clientHeight;
  }

  handleProductNameUpdate() {
    const productNameRef = this.querySelector('.minicart__product-name');

    if (!productNameRef) return;
    const textEl = productNameRef.querySelector('a');

    if (this.checkTitleIsClamp(textEl)) {
      this.addProductNameTooltip(productNameRef, textEl);
    }
  }

  addProductNameTooltip(productNameEl, titleEl) {
    // create tooltip content
    const tooltipContent = document.createElement('span');
    tooltipContent.className =
      'tooltip-custom-content invisible rounded-3 absolute pointer-none tooltip-width-custom';
    tooltipContent.style = '--tooltip-max-width:300px;';

    tooltipContent.textContent = titleEl.textContent;

    // update product name element
    productNameEl.classList.add('tooltip-custom');
    productNameEl.appendChild(tooltipContent);
  }

  setFlexContent() {
    if (!this.enableDynamicFlexContent) return;

    const infoEl = this.querySelector('.minicart__product-info');

    if (!infoEl) return;

    const titleEl = infoEl.querySelector('.minicart__product-name');

    if (!titleEl) return;

    if (this.isMultiLineProductName(titleEl)) {
      infoEl.classList.add('justify-between');
      const spacer = infoEl.querySelector('.product_info_spacer');

      if (spacer) {
        infoEl.removeChild(spacer);
      }
    } else {
      infoEl.classList.add('justify-start');
      if (!infoEl.querySelector('.product_info_spacer')) {
        this.createProductInfoSpacer(infoEl);
      }

      titleEl.classList.add('mb-4');
    }
  }

  isMultiLineProductName(titleEl) {
    // Get computed line-height to calculate expected height for 1 line
    const styles = window.getComputedStyle(titleEl);
    let lineHeight = parseFloat(styles.lineHeight);

    // If line-height is 'normal', calculate it based on font-size
    if (isNaN(lineHeight)) {
      const fontSize = parseFloat(styles.fontSize);
      lineHeight = fontSize * 1.2; // 'normal' is typically 1.2x the font-size
    }

    const scrollHeight = titleEl.scrollHeight;

    // If scrollHeight is greater than 1.5x line-height, text is overflowing
    const isOverflowing = scrollHeight > lineHeight * 1.5;

    return isOverflowing;
  }
  /**
   *
   * @param {Element} infoEl
   */
  createProductInfoSpacer(infoEl) {
    const cursorEl = this.querySelector('.minicart__item-prices');
    const spacer = document.createElement('div');
    spacer.className = 'product_info_spacer';
    if (!cursorEl) return;

    infoEl.insertBefore(spacer, cursorEl);
  }
  setupListeners() {
    window.addEventListener('load', () => this.setFlexContent());
    window.addEventListener('resize', () => this.setFlexContent());
  }
}

customElements.define('minicart-item', MinicartItem);

class CartItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // this.init();
  }

  init() {
    this.setFlexContent();
    this.setupListeners();
  }

  setFlexContent() {
    const infoEl = this.querySelector('.cart-item-mobile_wrapper_content_main');

    if (!infoEl) return;

    const titleEl = infoEl.querySelector('.product-item__name');

    if (!titleEl) return;

    if (this.isMultiLineProductName(titleEl)) {
      infoEl.classList.add('justify-between');
      const spacer = infoEl.querySelector('.product_info_spacer');

      if (spacer) {
        infoEl.removeChild(spacer);
      }
    } else {
      infoEl.classList.add('justify-start');
      if (!infoEl.querySelector('.product_info_spacer')) {
        this.createProductInfoSpacer(infoEl);
      }

      titleEl.classList.add('mb-4');
    }
  }

  isMultiLineProductName(titleEl) {
    // Get computed line-height to calculate expected height for 1 line
    const styles = window.getComputedStyle(titleEl);
    let lineHeight = parseFloat(styles.lineHeight);

    // If line-height is 'normal', calculate it based on font-size
    if (isNaN(lineHeight)) {
      const fontSize = parseFloat(styles.fontSize);
      lineHeight = fontSize * 1.2; // 'normal' is typically 1.2x the font-size
    }

    const scrollHeight = titleEl.scrollHeight;

    // If scrollHeight is greater than 1.5x line-height, text is overflowing
    const isOverflowing = scrollHeight > lineHeight * 1.5;

    return isOverflowing;
  }
  /**
   *
   * @param {Element} infoEl
   */
  createProductInfoSpacer(infoEl) {
    const cursorEl = this.querySelector('.minicart__item-prices');
    const spacer = document.createElement('div');
    spacer.className = 'product_info_spacer';
    if (!cursorEl) return;

    infoEl.insertBefore(spacer, cursorEl);
  }
  setupListeners() {
    window.addEventListener('load', () => this.setFlexContent());
    window.addEventListener('resize', () => this.setFlexContent());
  }
}

customElements.define('cart-item', CartItem);
